module.exports = __webpack_public_path__ + "img/instagram-logo.86714aa.png";